import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex h-[calc(100dvh-64px)] overflow-auto flex-col bg-gray-50" }
const _hoisted_2 = { class: "flex flex-col space-y-4 mb-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 pt-5 text-sm text-gray-400 [&>*]:pb-2" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-secondary" }, "Dine data"),
  /*#__PURE__*/_createElementVNode("p", null, "Du er ansvarlig for at dine personlige oplysninger er korrekte."),
  /*#__PURE__*/_createElementVNode("p", null, "Kontakt Q-Star hvis data skal rettes.")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "bg-white px-6 py-5 text-sm text-gray-400"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-secondary pb-4" }, "Dine stamdata", -1)
const _hoisted_6 = {
  role: "list",
  class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
}
const _hoisted_7 = { class: "m-0 flex justify-between p-0" }
const _hoisted_8 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Medarbejder nummer", -1)
const _hoisted_10 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_11 = { class: "m-0 flex justify-between p-0" }
const _hoisted_12 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Navn", -1)
const _hoisted_14 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_15 = { class: "m-0 flex justify-between p-0" }
const _hoisted_16 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Fødselsdato", -1)
const _hoisted_18 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_19 = {
  key: 1,
  class: "bg-white px-6 py-5 text-sm text-gray-400"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-secondary pb-4" }, "Din adresse", -1)
const _hoisted_21 = {
  role: "list",
  class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
}
const _hoisted_22 = { class: "m-0 flex justify-between p-0" }
const _hoisted_23 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Adresse", -1)
const _hoisted_25 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_26 = { class: "m-0 flex justify-between p-0" }
const _hoisted_27 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Post nummer", -1)
const _hoisted_29 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_30 = { class: "m-0 flex justify-between p-0" }
const _hoisted_31 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "By", -1)
const _hoisted_33 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_34 = {
  key: 2,
  class: "bg-white px-6 py-5 text-sm text-gray-400"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-secondary pb-4" }, "Dine kontaktoplysninger", -1)
const _hoisted_36 = {
  role: "list",
  class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
}
const _hoisted_37 = { class: "m-0 flex justify-between p-0" }
const _hoisted_38 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Mobil/Tlf. nr.", -1)
const _hoisted_40 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_41 = { class: "m-0 flex justify-between p-0" }
const _hoisted_42 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "E-mail adresse", -1)
const _hoisted_44 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_45 = {
  key: 3,
  class: "bg-white px-6 py-5 text-sm text-gray-400"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-secondary pb-4" }, "Nærmeste pårørende", -1)
const _hoisted_47 = {
  role: "list",
  class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
}
const _hoisted_48 = { class: "m-0 flex justify-between p-0" }
const _hoisted_49 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Type af pårørende", -1)
const _hoisted_51 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_52 = { class: "m-0 flex justify-between p-0" }
const _hoisted_53 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Navn", -1)
const _hoisted_55 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_56 = { class: "m-0 flex justify-between p-0" }
const _hoisted_57 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Adresse", -1)
const _hoisted_59 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_60 = { class: "m-0 flex justify-between p-0" }
const _hoisted_61 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Post nummer", -1)
const _hoisted_63 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_64 = { class: "m-0 flex justify-between p-0" }
const _hoisted_65 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "By", -1)
const _hoisted_67 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_68 = { class: "m-0 flex justify-between p-0" }
const _hoisted_69 = { class: "m-0 flex flex-col pb-2 pt-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-medium text-blue-900" }, "Mobil/Tlf. nr.", -1)
const _hoisted_71 = { class: "text-base font-medium leading-5 text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.info)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.info.employeeNumber), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.info.name), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formattedDate), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.info && _ctx.info.address)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("ul", _hoisted_21, [
              _createElementVNode("li", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.info.address.street), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.info.address.zipcode), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.info.address.city), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.info && _ctx.info.address)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("ul", _hoisted_36, [
              _createElementVNode("li", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.info.phoneNumber), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.info.email), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.info && _ctx.info.kin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("ul", _hoisted_47, [
              _createElementVNode("li", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.mapKinType(_ctx.info.kin.kinType)), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.info.kin.name), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.info.kin.address.street), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.info.kin.address.zipcode), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _hoisted_66,
                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.info.kin.address.city), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.info.kin.phoneNumber), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}